module.exports = __webpack_public_path__ + "static/media/icon-booth-rev-clothing.5f551a02.svg";